<template>
	<div>
		<case-form :schema="schemaShared" class="mt6" />
		<case-form :schema="schemaAssets" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">房地产</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaPropertyList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6 mb2">净商业利润</div>
		<j-accordion
			v-for="j in 3"
			:key="j"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ j }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaNetBusinessList(j)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form class="mt6" :schema="schemaExtra" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaShared() {
			return [
				{
					label: `资产负债表是否与别人共有、共享？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsIsSharedCN`,
					props: {
						suggest: {
							typeIncludes: `assetsIsSharedCN`
						},
						createOptions: {
							type: `assetsIsSharedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>如选择"是"，请完成以下问题：</div>`
					},
					bindTo: ""
				},
				{
					label: `共有、共享人士（说明关系）：`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsSharedWithCN`,
					props: {
						suggest: {
							typeIncludes: `assetsSharedWithCN`
						},
						createOptions: {
							type: `assetsSharedWithCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `比例（%）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsSharedRatioCN`,
					props: {
						suggest: {
							typeIncludes: `assetsSharedRatioCN`
						},
						createOptions: {
							type: `assetsSharedRatioCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaAssets() {
			return [
				{
					label: `现金和存款 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsCashAndSavingsCN`,
					props: {
						suggest: {
							typeIncludes: `assetsCashAndSavingsCN`
						},
						createOptions: {
							type: `assetsCashAndSavingsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `股票和债券 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsStocksAndBondsCN`,
					props: {
						suggest: {
							typeIncludes: `assetsStocksAndBondsCN`
						},
						createOptions: {
							type: `assetsStocksAndBondsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `私人财产 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsPersonalPropertyCN`,
					props: {
						suggest: {
							typeIncludes: `assetsPersonalPropertyCN`
						},
						createOptions: {
							type: `assetsPersonalPropertyCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `物业 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsRealEstateCN`,
					props: {
						suggest: {
							typeIncludes: `assetsRealEstateCN`
						},
						createOptions: {
							type: `assetsRealEstateCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `净商业利息 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsNetBusinessInterestCN`,
					props: {
						suggest: {
							typeIncludes: `assetsNetBusinessInterestCN`
						},
						createOptions: {
							type: `assetsNetBusinessInterestCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaExtra() {
			return [
				{
					label: `其他（请说明）(美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessOtherCN`,
					props: {
						suggest: {
							typeIncludes: `netBusinessOtherCN`
						},
						createOptions: {
							type: `netBusinessOtherCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `总资产 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetTotalCN`,
					props: {
						suggest: {
							typeIncludes: `assetTotalCN`
						},
						createOptions: {
							type: `assetTotalCN`,
							dataType: "number"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPropertyList(i) {
			return [
				{
					label: `城市和国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateCityAndCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `realEstateCityAndCountry${i}CN`
						},
						createOptions: {
							type: `realEstateCityAndCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `用途:个人`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateForPersonal${i}CN`,
					props: {
						suggest: {
							typeIncludes: `realEstateForPersonal${i}CN`
						},
						createOptions: {
							type: `realEstateForPersonal${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `用途:公司`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateForBusiness${i}CN`,
					props: {
						suggest: {
							typeIncludes: `realEstateForBusiness${i}CN`
						},
						createOptions: {
							type: `realEstateForBusiness${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `用途:出租  `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateForRental${i}CN`,
					props: {
						suggest: {
							typeIncludes: `realEstateForRental${i}CN`
						},
						createOptions: {
							type: `realEstateForRental${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `物业价值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateValue${i}CN`,
					props: {
						suggest: {
							typeIncludes: `realEstateValue${i}CN`
						},
						createOptions: {
							type: `realEstateValue${i}CN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaNetBusinessList(j) {
			return [
				{
					label: `公司名字`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessCompanyName${j}CN`,
					props: {
						suggest: {
							typeIncludes: `netBusinessCompanyName${j}CN`
						},
						createOptions: {
							type: `netBusinessCompanyName${j}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市和国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessCityAndCountry${j}CN`,
					props: {
						suggest: {
							typeIncludes: `netBusinessCityAndCountry${j}CN`
						},
						createOptions: {
							type: `netBusinessCityAndCountry${j}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `拥有比例`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessPercentageOwned${j}CN`,
					props: {
						suggest: {
							typeIncludes: `netBusinessPercentageOwned${j}CN`
						},
						createOptions: {
							type: `netBusinessPercentageOwned${j}CN`,
							dataType: "number"
						}
					}
				},
				{
					label: `网址`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessWebsite${j}CN`,
					props: {
						suggest: {
							typeIncludes: `netBusinessWebsite${j}CN`
						},
						createOptions: {
							type: `netBusinessWebsite${j}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `商业价值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessValue${j}CN`,
					props: {
						suggest: {
							typeIncludes: `netBusinessValue${j}CN`
						},
						createOptions: {
							type: `netBusinessValue${j}CN`,
							dataType: "number"
						}
					}
				}
			]
		}
	}
}
</script>
